"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
const https = __importStar(require("https"));
class RequestExecutor {
    constructor(host, logger) {
        this.agent = new https.Agent({
            rejectUnauthorized: false,
        });
        this.excludedOperationsFromLogging = ["changePassword"];
        this.execute = async (request) => {
            const requestConfig = {
                ...(request.options || {}),
                url: request.url,
                method: request.method,
                baseURL: this.host,
                data: request.data,
                headers: request.headers,
                httpsAgent: this.agent,
            };
            this.logger.debug("executing request", this.hideSensitiveData({
                requestConfig,
                request,
            }));
            const axiosResponse = (await axios_1.default.request(requestConfig));
            return axiosResponse.data;
        };
        // TODO: this method should be a part of logger
        this.hideSensitiveData = ({ requestConfig, request, }) => {
            const requestConfigCopy = { ...requestConfig };
            const requestCopy = { ...request };
            if (request.url === "/oauth/v2/token") {
                return {
                    requestConfig: this.removeDataFromReq(requestConfigCopy),
                    request: this.removeDataFromReq(requestCopy),
                };
            }
            return {
                requestConfig: this.removeAuthorizationHeader(requestConfigCopy),
                request: this.removeAuthorizationHeader(requestCopy),
            };
        };
        this.removeAuthorizationHeader = (req) => {
            if (req.headers && req.headers["Authorization"]) {
                const { Authorization, ...headers } = req.headers;
                req.headers = headers;
            }
            return this.removeVariablesFromSensitivePayload(req);
        };
        this.removeDataFromReq = (req) => {
            const { data, ...rest } = req;
            return rest;
        };
        this.removeVariablesFromSensitivePayload = (req) => {
            if (req.data &&
                this.excludedOperationsFromLogging.includes(req.data["operationName"])) {
                const { variables, ...rest } = req.data;
                req.data = rest;
            }
            return req;
        };
        this.host = host;
        this.logger = logger;
    }
}
exports.default = RequestExecutor;
//# sourceMappingURL=RequestExecutor.js.map